import { createContext, useContext } from 'react'

export type Theme = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

export interface Branding {
  primaryColor?: string // hex, e.g. "#DC6B2F"
  neutralColor?: string // hex, e.g. "#1C1B18"
}

export interface ThemeContextValue {
  theme: Theme
  resolvedTheme: ResolvedTheme
  setTheme: (t: Theme) => void
  applyBranding: (b: Branding) => void
  resetBranding: () => void
}

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'system',
  resolvedTheme: 'light',
  setTheme: () => {},
  applyBranding: () => {},
  resetBranding: () => {},
})

export function useTheme() {
  return useContext(ThemeContext)
}
